export class OrdersReq {
    OrdersbuyerCode?:string
}